<template>
  <v-card class="device-card" hover @click="cardClick">
    <v-container>
      <v-row align="start" justify="center">
        <v-container class="pa-0">
        <DeviceCardImage
          v-if="thumb && !(item.code)"
          class="mt-n2 mb-n2"
          :image="thumb"
        ></DeviceCardImage>
        </v-container>
      </v-row>
      <v-row v-if="item.code" justify="center">
        <v-card-text >
          <v-row>
            <v-col cols=12>
              <v-btn color="blue" @click="showQR">
                Show QR code
              </v-btn>
              <v-dialog max-width="400" v-model="showQrDialog">
                <v-card>
                  <v-card-text>
                    <v-row justify="center">
                      <canvas
                      ref="myCanvas"
                      id="myCanvas"
                      width="400"
                      height="400"
                      ></canvas>
                    </v-row>
                    <v-row justify="center">
                      {{item.code}}
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-col>
            <v-col cols=12>
              <v-btn color="red" @click="deleteDevice">
                Remove device
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title>{{deviceName}}</v-card-title>
      </v-row>
      <v-row v-else>
        <v-card-title>{{deviceName}}</v-card-title>
        <v-card-text class="text-left" >
          <p class="body-1">{{ item.description }} ({{item.serial}})</p>
        </v-card-text>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import QRCode from 'qrcode';
import DeviceCardImage from '@/components/Home/DeviceCardImage.vue';
import gql from 'graphql-tag';

const SUBCRIPTION_LATEST_DEVICE_THUMB = gql`
  subscription user_get_latest_thumb($device: String!) {
    files(
      where: {
        _and: {
          device_id: {
            _eq: $device
          }
          url: {
            _ilike: "%_thumb%"
          }
        }
      }
      order_by: {
        created: desc
      }
      limit: 1
    ) {
        id
        device_id
        url
        created
    }
  }
`;

const DELETE_DEVICE = gql`
  mutation delete_devices($id: String!) {
    delete_devices_by_pk (
      id: $id
    ) {
      id
      code
    }
  }
`;

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      default_thumb: {
        url: '/noimage.png',
        created: '20200601',
      },
      thumbnail: null,
      showQrDialog: false,
    };
  },
  components: {
    DeviceCardImage,
  },
  computed: {
    deviceName() {
      if (this.item.code) {
        return 'Unregistered device';
      }
      return this.item.name;
      // return this.item.name ? this.name.substring(0, 35) : 'N/A';
    },
    thumb() {
      // return false;
      return this.thumbnail || this.default_thumb;
    },
  },
  methods: {
    showQR(e) {
      console.log('showQRcode');
      e.preventDefault();
      this.showQrDialog = true;
      setTimeout(() => {
        QRCode.toCanvas(
          this.$refs.myCanvas,
          this.item.code,
          { width: 400, height: 400 },
          (error) => {
            if (error) console.error(error);
          },
        );
      }, 50);
    },
    cardClick(e) {
      console.log('cardClick');
      e.preventDefault();
      if (!this.item.code) {
        this.$router.push({ name: 'Device', params: { id: this.item.id } });
      }
    },
    deleteDevice(e) {
      console.log('deleteDevice');
      e.preventDefault();
      const { id } = this.item;
      console.log(id);
      this.$apollo.mutate({
        mutation: DELETE_DEVICE,
        variables: {
          id,
        },
      }).then((data) => {
        // Result
        console.log(data);
      }).catch((error) => {
        // Error
        console.error(error);
      });
    },
  },
  apollo: {
    $subscribe: {
      thumbnail: {
        // graphql query
        query: SUBCRIPTION_LATEST_DEVICE_THUMB,
        variables() {
          return {
            device: this.item.id,
          };
        },
        result(data) {
          // Let's update the local data
          const { files } = data.data;
          [this.thumbnail] = files;
        },
      },
    },
  },
};
</script>
<style scoped>
.device-card {
  width: 350px;
  height: 260px;
  overflow: hidden;
}
</style>
